import { Tag } from '@cian/components';
import * as React from 'react';

import { EPublishPeriod } from '../../../../json_query';
import { IPublishPeriodTag } from '../../../state/tags/definitions/publish_period';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPublishPeriodTagItemProps {
  tag: IPublishPeriodTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const periodsMap = {
  [EPublishPeriod.Today]: 'сегодня',
  [EPublishPeriod.Hour]: 'за час',
  [EPublishPeriod.Day]: 'за сутки',
  [EPublishPeriod.Week]: 'за неделю',
  [EPublishPeriod.TenDays]: 'за 10 дней',
  [EPublishPeriod.Month]: 'за месяц',
};

export const PublishPeriodTagItem = ({ tag, onDeleteClick, withNewTag }: IPublishPeriodTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === EPublishPeriod.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Опубликовано: {periodsMap[tag.value]}
    </TagComponent>
  );
};
